export default __webpack_public_path__ + "static/media/mongodb.b3cedf8e.png";